import React from 'react';
import PropTypes from 'prop-types';

import propTypeTheme from 'utils/prop-type-theme';

import cn from 'classnames';

import Accordion from 'components/accordion';
import ChapterLink from 'components/chapter-link';
import Icon from 'components/icon';

const ChapterNavigationList = ({ accordion, link, linkOrLinkList }) => {
  return (
    <Accordion {...accordion}>
      {({ Button, Collapse, isOpen }) => (
        <div className="chapter-navigation-list">
          <div className="chapter-navigation-list--header">
            <Button
              className={cn('chapter-navigation-list--toggle', {
                '-is-active': isOpen
              })}
            >
              <Icon fill={true} name={'small-arrow-down'} />
            </Button>

            <ChapterLink isHeader={true} {...link} />
          </div>

          <Collapse className="chapter-navigation-list--content">
            <ul className="link-list">
              {linkOrLinkList.map(({ link, linkOrLinkList }, index) => {
                if (link) {
                  return (
                    <li key={link.chapterNumber + String(index)}>
                      <ChapterLink {...link} />
                    </li>
                  );
                }

                if (linkOrLinkList) {
                  return (
                    <li
                      className="-has-button"
                      key={linkOrLinkList.title + String(index)}
                    >
                      <ChapterNavigationList {...linkOrLinkList} />
                    </li>
                  );
                }
              })}
            </ul>
          </Collapse>
        </div>
      )}
    </Accordion>
  );
};

ChapterNavigationList.propTypes = {
  accordion: PropTypes.exact(Accordion.propTypes),
  link: PropTypes.exact(ChapterLink.propTypes)
};

// PropTypes is mutated because linkOrLinkList refers to ChapterNavgiationList
ChapterNavigationList.propTypes.linkOrLinkList = PropTypes.arrayOf(
  PropTypes.exact({
    linkOrLinkList: PropTypes.exact(ChapterNavigationList.propTypes),
    link: PropTypes.exact(ChapterLink.propTypes)
  })
).isRequired;

ChapterNavigationList.defaultProps = {
  linkOrLinkList: []
};

ChapterNavigationList.propTypesMeta = 'exclude';

export default ChapterNavigationList;
